import {
  ChangeDetectionStrategy,
  Component,
  inject,
  input,
  InputSignal,
  output,
  OutputEmitterRef
} from '@angular/core';

import { MatMenuModule } from '@angular/material/menu';
import { IndustriesListComponent } from '@app/shared/components/industries-list/industries-list.component';
import { DialogService } from '@app/shared/services/shared/dialog.service';
import { Industry } from '@app/shared/types/models/industry/industry.model';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'proffeo-company-industries-list',
  imports: [MatMenuModule, IndustriesListComponent],
  changeDetection: ChangeDetectionStrategy.Eager,
  templateUrl: './company-industries-list.component.html'
})
export class CompanyIndustriesListComponent {
  private readonly dialogService: DialogService = inject(DialogService);
  private readonly translateService: TranslateService = inject(TranslateService);

  public readonly companyIndustries: InputSignal<Industry[]> = input.required<Industry[]>();
  public readonly deleteCompanyIndustry: OutputEmitterRef<Industry> = output<Industry>();

  protected readonly openCompanyIndustryDeleteConfirmationDialog: (companyIndustry: Industry) => void = (
    companyIndustry: Industry
  ): void => {
    this.dialogService
      .openConfirmationDialog({
        title: this.translateService.instant('company-industries.modals.delete-modal-title'),
        desc: this.translateService.instant('company-industries.modals.delete-modal-description', {
          value: companyIndustry.name
        })
      })
      .afterClosed()
      .subscribe(decision => {
        if (decision) {
          this.deleteCompanyIndustry.emit(companyIndustry);
        }
      });
  };

  protected openEditCompanyIndustryDialog(companyIndustry: Industry): void {
    this.dialogService.openEditCompanyIndustryDialog(companyIndustry);
  }
}
